var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_5305_68782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.97385 3.83562C9.90801 3.63313 9.72841 3.48977 9.51677 3.47062L6.63006 3.20855L5.48922 0.537603C5.40499 0.341372 5.21334 0.214722 5.00001 0.214722C4.78669 0.214722 4.59496 0.341372 4.51127 0.537603L3.37042 3.20855L0.48326 3.47062C0.271617 3.49015 0.0923996 3.63351 0.0261753 3.83562C-0.0396675 4.0381 0.0211398 4.2602 0.181207 4.40058L2.36333 6.31399L1.71993 9.14775C1.67286 9.35611 1.75373 9.57157 1.92661 9.69654C2.01954 9.76406 2.12872 9.79778 2.23828 9.79778C2.33243 9.79778 2.42665 9.77276 2.51081 9.7224L5.00001 8.23404L7.48876 9.7224C7.67134 9.8315 7.90091 9.82151 8.07341 9.69654C8.2463 9.57157 8.32717 9.35611 8.2801 9.14775L7.6367 6.31399L9.81882 4.40058C9.97881 4.2602 10.0397 4.03856 9.97385 3.83562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5305_68782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBStar);
export default __webpack_public_path__ + "static/media/b-star.4fcc36bcc44215df73dc92e52cc14285.svg";
export { ForwardRef as ReactComponent };